import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AppComponent} from './app.component';
import {CommonModuleP8} from '@Common/common-p8.module';
import {AccueilComponent} from './accueil/accueil.component';
import {AppRoutingModule} from './app-routing';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CoreModule} from '@Common/core/core.module';
import {DepositModule} from 'app/archivage/deposit/deposit.module';
import {MatCardModule} from '@angular/material/card';
import {FlexModule} from '@Common/widgets/flex-layout/flex/flex.module';
import {MatIconModule} from '@angular/material/icon';
import {GestionModule} from './gestion/gestion.module';
import {CheckGuardService} from '@Services/guards/check-guard.service';
import {CommonArchivageModule} from 'app/archivage/common/common.module';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {CustomPaginatorService} from '@Services/custom-paginator/custom-paginator.service';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MagDetailComponent } from './dashboard/mag-detail/mag-detail.component';
import {MatAngularModule} from "@Common/mat-angular.module";

/**
 * Mon module
 */

@NgModule({
    declarations: [
        AppComponent,
        AccueilComponent,
        DashboardComponent,
        MagDetailComponent,
    ],
  imports: [
    BrowserAnimationsModule,
    CoreModule,
    CommonModuleP8,
    AppRoutingModule,
    CommonModule,
    DepositModule,
    MatCardModule,
    FlexModule,
    MatIconModule,
    GestionModule,
    CommonArchivageModule,
    MatAngularModule
  ],
    providers: [
        CheckGuardService,
      {provide: MatPaginatorIntl , useClass: CustomPaginatorService},
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
